module.exports = __webpack_public_path__ + "static/img/lims.d44feba4.png";